import { forwardRef, useState } from "react";
import DatePicker from 'react-datepicker';
import styled from "styled-components";
import { media } from "../common-data";
import { pxToRem } from "../utils/ConvertUtils";
import i18n from "../i18n/i18n";

interface BTInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const BTInput = styled.input<BTInputProps>`
  height: ${pxToRem(64)};
  border: 1px solid #B2B2B2;
  border-radius: 8px;
  padding: 0 ${pxToRem(22)};
  font-size: ${pxToRem(26)};
  font-weight: 400;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  color: #444;
  caret-color: #444;
  color-scheme: light;
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};

  &::placeholder {
    color: #b2b2b2;
    font-weight: 300;
  }

  &:focus {
    border-color: #888;
  }

  ${media.mobile`
    height: 40px;
    padding: 0 12px;
  `}
`;

// DatePicker에 custom input으로 넘길 컴포넌트
const CustomInput = forwardRef(({ value, onClick }: any, ref: any) => (
  <BTInput
    onClick={onClick}
    value={value}
    readOnly
    ref={ref}
    placeholder="날짜를 선택하세요"
  />
));

export const DateInput = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  return (
    <DatePicker
      selected={selectedDate}
      onChange={(date) => setSelectedDate(date)}
      dateFormat="yyyy-MM-dd"
      customInput={<CustomInput />}
      popperPlacement="bottom-start"
    />
  );
};
